var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M16,32c8.822,0,16-7.178,16-16S24.822,0,16,0S0,7.178,0,16S7.178,32,16,32z M16,1c8.271,0,15,6.729,15,15 s-6.729,15-15,15S1,24.271,1,16S7.729,1,16,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M20.061,21.768c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146 c0.195-0.195,0.195-0.512,0-0.707L16,16.293V9.319c0-0.276-0.224-0.5-0.5-0.5S15,9.043,15,9.319V16.5 c0,0.133,0.053,0.26,0.146,0.354L20.061,21.768z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 4,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 28,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 16,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 16,
    cy: 28,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 8,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 24,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 25,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 8,
    cy: 24,
    r: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.58780bd8c5ef58d7614365aecc39026a.svg";
export { ForwardRef as ReactComponent };